@if (visible()) {
  <div class="cookie-banner">
    <div class="cookie-content">
      <div class="cookie-text">
        <i class="pi pi-shield text-lg"></i>
        <p>
          Acest site folosește cookie-uri pentru a asigura funcționarea corectă a platformei.
          Consultați <a routerLink="/confidentialitate" class="underline font-medium">Politica de Confidențialitate</a>
          și <a routerLink="/termeni" class="underline font-medium">Termenii și Condițiile</a> pentru detalii.
        </p>
      </div>
      <div class="cookie-actions">
        <p-button label="Accept" icon="pi pi-check" size="small" (onClick)="accept()" />
        <p-button label="Refuz" icon="pi pi-times" size="small" severity="secondary" [outlined]="true" (onClick)="reject()" />
      </div>
    </div>
  </div>
}
